const routes = [
     //共享饭店
    {
        path: '/sharedHotel/cardHome',
        component: () =>
            import ('../pages/shared-hotel/cardHome.vue'),
        meta: {
            title: '卡包',
        },
    },
    {
        path: '/sharedHotel/usageRecord',
        component: () =>
            import ('../pages/shared-hotel/usageRecord.vue'),
        meta: {
            title: '使用记录',
        },
    },
    {
        path: '/sharedHotel/usingHelp',
        component: () =>
            import ('../pages/shared-hotel/usingHelp.vue'),
        meta: {
            title: '使用帮助',
        },
    },
    {
        path: '/sharedHotel/cardRecharge',
        component: () =>
            import ('../pages/shared-hotel/cardRecharge.vue'),
        meta: {
            title: '卡包充值',
        },
    },
    {
        path: '/sharedHotel/confirmRechange',
        component: () =>
            import ('../pages/shared-hotel/confirmRechange.vue'),
        meta: {
            title: '确认充值',
        },
    },
    {
        path: '/sharedHotel/cardHome1',
        component: () =>
            import ('../pages/shared-hotel/cardHome1.vue'),
        meta: {
            title: '卡包1',
        },
    },
    {
        path: '/sharedHotel/store',
        component: () =>
            import ('../pages/shared-hotel/store.vue'),
        meta: {
            title: '适用门店',
            keepAlive: true,
        }
    },
    {
        path: '/sharedHotel/store1',
        component: () =>
            import ('../pages/shared-hotel/store1.vue'),
        meta: {
            title: '适用门店1',
            keepAlive: true,
        },
    },
    {
        path:'/sharedHotel/storeDetail',
        component:()=>import('../pages/shared-hotel/storeDetail.vue'),
        meta:{
            title:'店铺详情'
        }
    },
    {
        path:'/sharedHotel/storeSearch',
        component:()=>import('../pages/shared-hotel/storeSearch.vue'),
        meta:{
            title:'搜索店铺'
        }
    },
    {
        path:'/sharedHotel/immediatelyPay',
        component:()=>import('../pages/shared-hotel/immediatelyPay.vue'),
        meta:{
            title:'立即核销'
        }
    },
    {
        path:'/sharedHotel/sharedCertificate',
        component:()=>import('../pages/shared-hotel/sharedCertificate.vue'),
        meta:{
            title:'营业资质'
        }
    },
    {
        path:'/sharedHotel/paymentResult',
        component:()=>import('../pages/shared-hotel/paymentResult.vue'),
        meta:{
            title:'支付成功'
        }
    },
    {
        path:'/sharedHotel/cardbalance',
        component:()=>import('../pages/shared-hotel/cardbalance.vue'),
        meta:{
            title:'卡包余额'
        }
    },
    {
        path:'/sharedHotel/cardbalanceDetail',
        component:()=>import('../pages/shared-hotel/cardbalanceDetail.vue'),
        meta:{
            title:'卡包余额详情',
        }
    },
    {
        path:'/sharedHotel/givingCredits',
        component:()=>import('../pages/shared-hotel/givingCredits.vue'),
        meta:{
            title:'赠送额度',
        }
    },
    {
        path: '/sharedHotel/adv',
        component: () =>
            import ('../pages/shared-hotel/adv.vue'),
        meta: {
            title: 'H5广告页面-共享饭店加盟',
        },
    },
    {
        path:'/sharedHotel/scanstoreDetail',
        component:()=>import('../pages/shared-hotel/scanstoreDetail'),
        meta:{
            title:'扫码订单的立即买单'
        }
    },
    //红包提示
    {
        path: '/red-envelope',
        component: () =>
            import ('@/pages/envelope'),
        meta: {
            title: '红包提示'
        }
    }
];
export default routes;